(function($) {
    $(document).ready(function() {
        initSwiper();
    });

    function initSwiper() {
        const thumbnailSwiper = new Swiper('.thumbnail-swiper', {
            slidesPerView: 1,
            autoHeight: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

        thumbnailSwiper.on('slideChange', function (e) {
            $('.thumbnail-swiper .pagination-count .current-index').text(thumbnailSwiper.activeIndex + 1);
        });
    }
})(jQuery);
